const zIndex = {
  appbar: 1100,
  drawer: 1200,
  modal: 1300,
  toast: 1400,
  tooltip: 1500,
}

export default zIndex
